/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
  NotificationsDispatchPublicControllerEmailAutoLoginQueryParams,
} from '../../types/NotificationsDispatchPublicControllerEmailAutoLogin.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { notificationsDispatchPublicEmailAutoLogin } from '../../methods/notificationsDispatchPublicEmailAutoLogin.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const notificationsDispatchPublicEmailAutoLoginQueryKey = (
  params: NotificationsDispatchPublicControllerEmailAutoLoginQueryParams,
) => [{ url: '/api/telegram/notifications/email-auto-login' }, ...(params ? [params] : [])] as const;

export type NotificationsDispatchPublicEmailAutoLoginQueryKey = ReturnType<
  typeof notificationsDispatchPublicEmailAutoLoginQueryKey
>;

export function notificationsDispatchPublicEmailAutoLoginQueryOptions(
  params: NotificationsDispatchPublicControllerEmailAutoLoginQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = notificationsDispatchPublicEmailAutoLoginQueryKey(params);
  return queryOptions<
    NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
    ResponseErrorConfig<Error>,
    NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return notificationsDispatchPublicEmailAutoLogin(params, config);
    },
  });
}

/**
 * {@link /api/telegram/notifications/email-auto-login}
 */
export function useNotificationsDispatchPublicEmailAutoLogin<
  TData = NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
  TQueryData = NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
  TQueryKey extends QueryKey = NotificationsDispatchPublicEmailAutoLoginQueryKey,
>(
  params: NotificationsDispatchPublicControllerEmailAutoLoginQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        NotificationsDispatchPublicControllerEmailAutoLoginQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationsDispatchPublicEmailAutoLoginQueryKey(params);

  const query = useQuery(
    {
      ...notificationsDispatchPublicEmailAutoLoginQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
